import styled from 'styled-components'
import Link from '../../atoms/Link/Link'
import colors from '../../theme/colors'
import DPGRLogo from '../FormHeader/DPGRLogo'

export const MOBILE_HEADER_HEIGHT = '72px'

export const Wrapper = styled.div`
  position: sticky;
  top: 0;
  width: 100vw; // show header as wide as screen regardless of page content
  height: ${MOBILE_HEADER_HEIGHT};
  background-color: ${colors.Primary.Black};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  z-index: 1;
`

export const LogoLink = styled(Link)`
  padding: 0 32px; // increase link button  
`

export const StyledDPGRLogo = styled(DPGRLogo)`
  height: 48px;
`
